import React from 'react';
import { useSearchParams } from 'react-router-dom';

import EmailVerifiedSuccessfully from "./EmailVerifiedSuccessfully.jsx";
import ResetPassword from "./ResetPassword.jsx";

const FirebaseLinkPages = () => {
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode');

    if (mode === 'verifyEmail') {
        return <EmailVerifiedSuccessfully />;
    } else if (mode === 'resetPassword') {
        return <ResetPassword />;
    } else {
        return <div className="firebase-link-page">Invalid link or action.</div>;
    }
};

export default FirebaseLinkPages;
